import { useState } from 'react';
import { useIsomorphicLayoutEffect } from './use-isomorphic-layout-effect.js';
import { ROOT_CLASSNAMES } from '../../core/constants/globals.js';

/**
 * The hook accepts a ref to an element returns a boolean based on the fact,
 * if it's enclosed within dark mode or not.
 */ function useDarkModeExtractor(elementRef) {
    const [hasDarkMode, setHasDarkMode] = useState(false);
    useIsomorphicLayoutEffect(()=>{
        var _elementRef_current;
        const closestDarkModeElem = (_elementRef_current = elementRef.current) === null || _elementRef_current === void 0 ? void 0 : _elementRef_current.closest(`.${ROOT_CLASSNAMES.darkMode}`);
        if (closestDarkModeElem) {
            const hasNestedLightModeElem = !!closestDarkModeElem.querySelector(`.${ROOT_CLASSNAMES.lightMode}`);
            setHasDarkMode(!hasNestedLightModeElem);
        }
    }, [
        elementRef
    ]);
    return hasDarkMode;
}

export { useDarkModeExtractor };
